import { Component } from "../component"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { deviceWidth } from "../helpers/device-size"

gsap.registerPlugin(ScrollTrigger)

export class BlogStoriesPreview extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      header: ".blog-stories-preview-header-text",
      featuredImage:
        ".blog-stories-preview-cards .blog-story-card-1 .blog-story-card-image",
      leftImageTop: ".blog-stories-preview-cards .blog-story-card-2",
      rightImageTop: ".blog-stories-preview-cards .blog-story-card-4",
      leftImageBottom: ".blog-stories-preview-cards .blog-story-card-5",
      rightImageBottom: ".blog-stories-preview-cards .blog-story-card-7",
    }
  }

  animateElements() {
    const {
      header,
      featuredImage,
      leftImageTop,
      rightImageTop,
      leftImageBottom,
      rightImageBottom,
    } = this.$ui

    const deviceType = deviceWidth()

    if (deviceType === "PHONE" || deviceType === "TABLET") {
      return
    }

    gsap.from([header, featuredImage], {
      y: 200,
      duration: 1.5,
      ease: "power2.inOut",
      stagger: 0.02,
      scrollTrigger: {
        trigger: header,
        start: "top-=300 bottom",
        onLeave: () => {
          gsap.set(header, { y: 0 })
          gsap.set(featuredImage, { y: 0 })
        },
        onLeaveBack: () => {
          gsap.set(header, { y: 0 })
          gsap.set(featuredImage, { y: 0 })
        },
      },
    })

    gsap.from([leftImageTop, rightImageTop], {
      y: 150,
      duration: 1.5,
      ease: "power2.inOut",
      stagger: 0.2,
      scrollTrigger: {
        trigger: leftImageTop,
        start: "top-=170 bottom",
        onLeave: () => {
          gsap.set(leftImageTop, { y: 0 })
          gsap.set(rightImageTop, { y: 0 })
        },
        onLeaveBack: () => {
          gsap.set(leftImageTop, { y: 0 })
          gsap.set(rightImageTop, { y: 0 })
        },
      },
    })

    gsap.from([leftImageBottom, rightImageBottom], {
      y: 150,
      duration: 1.5,
      ease: "power2.inOut",
      stagger: 0.2,
      scrollTrigger: {
        trigger: leftImageBottom,
        start: "top-=170 bottom",
        onLeave: () => {
          gsap.set(leftImageBottom, { y: 0 })
          gsap.set(rightImageBottom, { y: 0 })
        },
        onLeaveBack: () => {
          gsap.set(leftImageBottom, { y: 0 })
          gsap.set(rightImageBottom, { y: 0 })
        },
      },
    })

    gsap.fromTo(
      leftImageBottom,
      {
        y: 0,
      },
      {
        y: "-20%",
        duration: 1.2,
        ease: "power2.inOut",
        scrollTrigger: {
          trigger: leftImageBottom,
          start: "60% top",
          onLeave: () => gsap.set(leftImageBottom, { y: 0 }),
          onLeaveBack: () => gsap.set(leftImageBottom, { y: 0 }),
        },
      }
    )
  }

  created() {
    this.animateElements()
  }
}
